// Order + labels for the three stratified recommendation feeds.
export const CATEGORIES = [
  { key: "court", label: "Court Rentals" },
  { key: "private", label: "Private Lessons" },
  { key: "class", label: "Group Classes" }
];

// Map a recommendation slot + chosen option (court / trainer) to the exact cart
// item the category's normal slot-click produces (see each view's
// handleSlotSelect). Booking then behaves identically to the booking flow: add
// to cart and go to checkout (the API re-validates availability at booking time).
//
// `courtIsOurs` is false only when the client picked a specific COURT from the
// card's option rows. Everything else — "Any court", a card with no choice to
// offer, and every private lesson (whose court is always resolved server-side,
// whichever trainer was chosen) — is a system pick and carries `facilityAuto`
// so the court re-organization may still move it.
export function cartItemFor(slot, option, currency, courtIsOurs = true) {
  const common = {
    date: slot.date,
    time: slot.time,
    duration: slot.duration,
    serviceId: slot.serviceId,
    pricingId: slot.pricingId,
    price: slot.price,
    currency: slot.currency || currency,
    locationId: slot.locationId,
    locationName: slot.locationName
  };
  if (slot.category === "court") {
    return ["court", { type: "court", ...common, facilityId: option.facilityId, facilityName: option.facilityName, facilityAuto: !!courtIsOurs }];
  }
  if (slot.category === "private") {
    return [
      "lesson",
      {
        type: "lesson",
        ...common,
        // Named the same way the booking flow names it, so checkout says
        // "Hitting" rather than the category it belongs to.
        serviceName: slot.serviceName,
        trainerId: option.trainerId,
        trainerName: option.trainerName,
        ...(option.facilityId && { facilityId: option.facilityId, facilityName: option.facilityName, facilityAuto: true })
      }
    ];
  }
  return [
    "class",
    {
      type: "class",
      ...common,
      bookishId: slot.bookishId,
      name: slot.serviceName,
      trainerId: option.trainerId,
      trainerName: option.trainerName,
      facilityId: option.facilityId,
      facilityName: option.facilityName
    }
  ];
}

// Label for a single option in the picker / card meta.
export function optionLabel(slot, option) {
  return (slot.category === "court" ? option.facilityName : option.trainerName) || (slot.category === "court" ? "Court" : "Trainer");
}

// Compact label for a date chip: Today / Tomorrow / "Mon 30".
export function shortDateLabel(iso) {
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  const today = new Date();
  const t0 = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const d0 = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diff = Math.round((d0 - t0) / 86400000);
  if (diff === 0) return "Today";
  if (diff === 1) return "Tomorrow";
  // Weekday-first ("Thu 2"), keeping the localized weekday name but a fixed order.
  return `${d.toLocaleDateString(undefined, { weekday: "short" })} ${d.getDate()}`;
}
